export default {
  page: 1,
  paginate: 10,
  lengthItems: 0,
  maxPagesInPagination: 10,
  next_page_url: null,
  prev_page_url: null
}